var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudZeeve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_406_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0.294312H0V27.2943H28V0.294312Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_406_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9288 5.89495C11.9288 8.97259 9.4621 11.4674 6.419 11.4674C3.376 11.4674 0.908203 8.97259 0.908203 5.89495C0.908203 2.8173 3.375 0.32251 6.419 0.32251C9.4611 0.32251 11.9288 2.8173 11.9288 5.89495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0811 21.2197C27.0811 24.2973 24.6143 26.7921 21.5713 26.7921C18.5282 26.7921 16.0615 24.2973 16.0615 21.2197C16.0615 18.142 18.5282 15.6472 21.5713 15.6472C24.6143 15.6472 27.0811 18.142 27.0811 21.2197Z",
    fill: "#088DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9288 21.2197C11.9288 24.2973 9.4621 26.7921 6.419 26.7921C3.376 26.7921 0.908203 24.2973 0.908203 21.2197C0.908203 18.142 3.375 15.6472 6.419 15.6472C9.4611 15.6472 11.9288 18.142 11.9288 21.2197Z",
    fill: "#088DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0811 5.89495C27.0811 8.97259 24.6143 11.4674 21.5713 11.4674C18.5282 11.4674 16.0615 8.97259 16.0615 5.89495C16.0615 2.8173 18.5282 0.32251 21.5713 0.32251C24.6143 0.32251 27.0811 2.8173 27.0811 5.89495Z",
    fill: "#32B8B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7864 19.6335C11.7864 19.6335 12.3896 20.2768 14.1973 20.2768C16.005 20.2768 16.9522 18.2399 16.9522 18.2399L18.8776 26.061C15.5833 24.3821 12.6708 24.0624 9.37549 25.9027L11.7864 19.6335Z",
    fill: "#088DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57471 15.7229C5.57471 15.7229 11.0287 14.4836 13.306 12.1643C15.5833 9.84494 16.0609 5.89502 16.0609 5.89502L22.5747 11.2859C22.5747 11.2859 17.6502 12.6312 15.3729 14.9505C13.0956 17.2698 11.929 20.5229 11.929 20.5229L5.57471 15.7229Z",
    fill: "url(#paint0_linear_406_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_2",
    x1: 9.01461,
    y1: 18.2439,
    x2: 18.9925,
    y2: 8.7768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088DB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B8B2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white",
    transform: "translate(0 0.294312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudZeeve);
export default __webpack_public_path__ + "static/media/cloud-zeeve.fe36474fb27dd7154c3fba1fcc399ebd.svg";
export { ForwardRef as ReactComponent };